import { AppRouteGroup } from 'routing/classes/AppRouteGroup';

export const salariesRouteGroup = new AppRouteGroup('/i');

export const viewUserProfileRoute = salariesRouteGroup.route(':username');
